export const GET_GROUNDED_OPACITY_VALUES = [
  [0, 0, 0],
  [0.43, 0, 0],
  [0.43, 0.43, 0],
  [0.43, 0.43, 0.43],
];
